import { HttpParams } from '@angular/common/http';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AddressInfo, TableDocTypes } from 'src/app/entities/various';
import { LoginService, UserData } from 'src/app/services/login/login.service';
import { UserService } from 'src/app/services/users/user.service';

@Component({
  selector: 'app-ricerca-indirizzo',
  templateUrl: './ricerca-indirizzo.component.html',
  styleUrls: ['./ricerca-indirizzo.component.css']
})
export class RicercaIndirizzoComponent implements OnInit {

  innerWidth: number | undefined = window.innerWidth;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  @Input() type: {type: string, description: string} | undefined;

  searchFilter : string = "denominazione";
  titleSearch: string = "";

  loading : boolean = false;
  first: boolean = true;
  listAddress : AddressInfo[] = [];

  previousPage : number = 1;
  nextPage : number = 1;
  currentPage : number = 1;

  constructor(public translate: TranslateService, public activeModal: NgbActiveModal, private loginService: LoginService, private userService: UserService) {
    this.innerWidth = window.innerWidth;
  }

  async ngOnInit() {
    this.retriveList();
  }

  close(){
    this.activeModal.close(null);
  }

  search(event: any){
    if(this.titleSearch.length < 3 ) return;
    if(!event || event.keyCode == 13){
      this.retriveList();
    }
  }

  private async retriveList(){
    this.loading = true;
    this.listAddress = [];
    //let userInfo = await this.loginService.getSessionUserInfo();
    let userInfo: UserData = JSON.parse(localStorage.getItem("einvuser") || "");
    let params = new HttpParams();
    params = params.append('endRow', 0);
    params = params.append('lastKeyVal', '');
    params = params.append('page', this.currentPage);
    params = params.append('pageDirection', 'FORWARD');
    params = params.append('pageSize', 10);
    params = params.append('pagination', true);
    params = params.append('paginationMode', 'SKIP');
    params = params.append('searchFilter', '{\"tipo\":\"' + this.type!.type +'\",\"' + this.searchFilter + '\":\"' + this.titleSearch + '\"}');
    
    params = params.append('sortDir', 'ASC');
    params = params.append('sortKey', this.searchFilter);
    params = params.append('startRow', 1);
    params = params.append('totalPages', 0);
    params = params.append('totalRows', 0);
    
    let response = await this.userService.searchAddress(userInfo!.user_id, params);
    if(response.success){
      let table : TableDocTypes = response.data as TableDocTypes;
      if((table.totalPages!= this.currentPage ) && (table.totalPages > this.nextPage ))
                this.nextPage=table.totalPages;
      
      this.listAddress = table.data;
    }
    this.first = false;
    this.loading = false;
  }

  prev(){
    this.currentPage=this.currentPage-1;
    this.retriveList();
  }

  next(){
    this.currentPage=this.currentPage+1;
    this.retriveList();
  }




  public selectOne(doc: AddressInfo){
    if(doc.selected){
      this.listAddress.filter(d => d.id != doc.id).forEach(d => d.selected = false);
    }
  }

  public save(){
    if(this.listAddress.filter(d => d.selected).length > 0){
      this.activeModal.close(this.listAddress.filter(d => d.selected)[0]);
    } else {
      this.activeModal.close(null);
    }
  }
}
